import { compactCarImages } from "./carImages";

export const buildCheckInOutSnapshot = ({ carImages, fuelLevel, mileage }) => {
    const images = compactCarImages(carImages || {});
    const snapshot = {
        carImages: Object.keys(images).length > 0 ? images : null,
        mileage: mileage ?? null,
        fuelLevel: fuelLevel !== undefined && fuelLevel !== null ? String(fuelLevel) : null,
    };

    const hasData = snapshot.carImages || snapshot.mileage != null || snapshot.fuelLevel;
    return hasData ? snapshot : undefined;
};

export const buildCheckInReservationPatch = ({
    carImages,
    fuelLevel,
    mileage,
    preserveOngoing,
    reservationOngoing,
    earlyPickupDateTime,
    earlyCheckInInvoice,
}) => {
    const checkIn = buildCheckInOutSnapshot({ carImages, fuelLevel, mileage });
    const payload = {};

    if (checkIn) {
        payload.checkIn = checkIn;
        payload.isDashboardImageUploaded = Boolean(checkIn.carImages?.dashboard);
    }

    payload.pickupReady = true;
    payload.exactPickupTime = earlyPickupDateTime || new Date().toISOString();
    payload.ongoing = preserveOngoing ? reservationOngoing ?? false : true;

    if (earlyCheckInInvoice) {
        payload.invoice = earlyCheckInInvoice;
    }

    return payload;
};
